import { useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";

import Typography from "../../base-components/Typography";
import { MILESTONES, getActiveMilestoneIndex } from "../../utils/steps";

// Persistent orientation for the linear claim-intake wizard. Renders nothing
// on routes that aren't part of the happy path (home, thank-you, legacy).
const StepIndicator = () => {
  const { pathname } = useLocation();
  const activeIndex = getActiveMilestoneIndex(pathname);

  if (activeIndex === -1) return null;

  const active = MILESTONES[activeIndex];

  return (
    <div className="pb-4 pt-1">
      <div className="flex items-center gap-1.5">
        {MILESTONES.map((milestone, index) => (
          <div
            key={milestone.key}
            className={twMerge([
              "h-1 flex-1 rounded-full transition-colors duration-300 ease-out",
              index < activeIndex && "bg-primary",
              index === activeIndex && "bg-secondary",
              index > activeIndex && "bg-dark-12",
            ])}
          />
        ))}
      </div>
      <div className="mt-2 flex items-baseline justify-between">
        <Typography size="sm" className="text-black-64">
          {active.label}
        </Typography>
        <Typography size="sm" className="text-black-64 tabular-nums">
          {activeIndex + 1}/{MILESTONES.length}
        </Typography>
      </div>
    </div>
  );
};

export default StepIndicator;
